
import Vue from "vue";
import AppDossierEditForm from "./DossierEditForm.vue";
import { Dossier } from "@/models/dossier";
import { Company } from "@/models/company";
import { CompanyDossierService } from "@/services/company-dossier-service";

export default Vue.extend({
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		value: {
			type: Object as ()=>Dossier,
			required: true
		}
	},
	methods: {
		async save() {
			let result = await CompanyDossierService.createDossier(this.company.id, this.value);
			this.$emit("input", result);
			this.$emit("close");
		},
		cancel() {
			this.$emit("close");
		}
	},
	components: {
		AppDossierEditForm
	}
});
